export default "__VITE_ASSET__Uu5x8O4N__"